import { reactive } from 'vue'
import { loginCommonConfig } from './common'
import type { LoginPageConfig } from './types'

export const theme = {
  facebookBlue: '#1A77F2',
  googleBlue: '#239FFB',
  appleDark: '#282828',
  inputBorder: '#ffffff1a',
} as const

export const resources = {
  loginBg: '/images/marinovel/login/login-bg.webp',
  logo: '/images/marinovel/logo.webp',
  novel: '/images/marinovel/login/roc-novel.png',
  facebookIcon: '/images/marinovel/login/icon-facebook-logo.png',
  googleIcon: '/images/marinovel/login/icon-google-logo.png',
  appleIcon: '/images/marinovel/login/icon-apple-logo.png',
  emailIcon: '/images/marinovel/login/icon-email.png',
  emailCodeIcon: '/images/marinovel/login/icon-email-code.png',
} as const

export const loginConfig: LoginPageConfig = {
  theme,
  resources,
  texts: reactive(loginCommonConfig.texts),
}
